const header = {
  header: {
    logOut: 'Sair',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Suporte Enphase',
    comingSoon: 'Em breve',
    new: 'Novo',
    dashboard: 'Painel',
    systems: 'Sistemas',
    account: 'Conta',
    services: 'Serviços',
    dataPrivacy: 'Dados privados',
    support: 'Suporte',
    admin: 'Admin',
    adminNew: 'Admin (Novo)'
  }
};
export default header;
